import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ShieldCheck, Lock } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  const faqs = [{
    q: '¿Es esto contra mi religión?',
    a: 'Al contrario. Este proceso se basa en el principio bíblico de la libertad en Cristo y el perdón generacional. Juan 8:32 dice: "Y conoceréis la verdad, y la verdad os hará libres." Eso es exactamente lo que este manual te ayuda a experimentar.'
  }, {
    q: '¿Tengo que hablar con mi familia para que esto funcione?',
    a: 'No. Este es un trabajo completamente interno y espiritual. No necesitas el permiso ni la participación de nadie más. Tu sanación es tuya y solo tuya. De hecho, al liberarte tú, el sistema familiar completo comienza a sanar sin que nadie más tenga que hacer nada.'
  }, {
    q: '¿Cuánto tiempo toma al día?',
    a: 'Entre 15 y 20 minutos diarios durante 7 días. Puedes hacerlo antes de dormir, en tu tiempo de oración o en cualquier momento de quietud. Está diseñado para la vida real de una mujer ocupada.'
  }, {
    q: '¿Es seguro hacer este proceso sola?',
    a: 'Completamente. El proceso fue diseñado para ser un acompañamiento compasivo y suave. No es confrontacional ni traumático. Es un acto de amor hacia ti misma y hacia tu historia. Si en algún momento sientes emociones muy intensas, date permiso de pausar y respirar. Eso también es parte de la sanación.'
  }, {
    q: '¿Qué pasa si compro y no funciona para mí?',
    a: 'Tienes 30 días de garantía total. Si aplicas el proceso completo y no sientes ningún cambio real, te devolvemos cada centavo sin preguntas y sin complicaciones. El riesgo es completamente nuestro.'
  }];
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <section id="offer-section" className="pt-10 pb-20 px-4 bg-cream" data-id="element-135">
      <div className="max-w-4xl mx-auto" data-id="element-136">
        {/* FAQ */}
        <div className="mb-24" data-id="element-137">
          <h2 className="text-3xl font-serif text-charcoal font-bold mb-10 text-center" data-id="element-138">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4 max-w-2xl mx-auto" data-id="element-139">
            {faqs.map((faq, i) => <div key={i} className="bg-white border border-gold/20 shadow-sm" data-id="element-140">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-141">
                  <span className={`font-serif font-bold text-lg ${openFaq === i ? 'text-gold-dark' : 'text-charcoal'}`} data-id="element-142">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-gold transition-transform duration-300 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-143" />
                </button>
                <AnimatePresence data-id="element-144">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-145">
                      <div className="px-6 pb-4 text-charcoal-light" data-id="element-146">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-gold p-8 md:p-12 text-center mb-24 relative shadow-lg" data-id="element-147">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-cream rounded-full p-2" data-id="element-148">
            <div className="bg-gold text-white rounded-full p-4 shadow-md" data-id="element-149">
              <ShieldCheck size={40} data-id="element-150" />
            </div>
          </div>

          <h3 className="text-2xl font-serif font-bold text-charcoal mt-6 mb-4" data-id="element-151">
            NUESTRA PROMESA Y GARANTÍA DE FE TOTAL (30 DÍAS)
          </h3>
          <p className="text-charcoal-light leading-relaxed" data-id="element-152">
            Estamos tan seguros de la potencia de este proceso que el riesgo es
            todo nuestro. Si descargas el manual, aplicas los pasos durante 7
            días y no sientes una liberación real en tu espíritu o una claridad
            absoluta sobre tu camino,{' '}
            <strong className="text-charcoal" data-id="element-153">
              te devolvemos el 100% de tu inversión.
            </strong>{' '}
            Sin preguntas, sin complicaciones. Tu sanación es nuestra única
            prioridad.
          </p>
        </motion.div>

        {/* Offer & Price */}
        <div className="text-center bg-white p-8 md:p-12 shadow-xl border border-gold/30 relative overflow-hidden" data-id="element-154">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-bl-full -z-10" data-id="element-155"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-gold/10 rounded-tr-full -z-10" data-id="element-156"></div>

          <h3 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-8" data-id="element-157">
            Esta Semana Santa, tienes dos caminos.
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto text-left" data-id="element-158">
            {/* Camino A */}
            <div className="bg-cream-light border border-gray-200 p-6 rounded-sm" data-id="element-159">
              <p className="font-serif font-bold text-charcoal-light text-lg mb-3 flex items-center gap-2" data-id="element-160">
                <span className="text-red-400/80 text-xl" data-id="element-161">✕</span> CAMINO A
              </p>
              <p className="text-sm text-charcoal-light italic mb-2 font-semibold" data-id="element-162">
                Sin este manual:
              </p>
              <p className="text-charcoal-light text-sm leading-relaxed" data-id="element-163">
                Otra semana, otro mes, otro año sintiendo el mismo peso. Tus
                hijos heredando lo que tú heredaste.
              </p>
            </div>

            {/* Camino B */}
            <div className="bg-charcoal border border-gold/30 p-6 rounded-sm" data-id="element-164">
              <p className="font-serif font-bold text-gold text-lg mb-3 flex items-center gap-2" data-id="element-165">
                <span className="text-gold text-xl" data-id="element-166">✓</span> CAMINO B
              </p>
              <p className="text-sm text-gold/80 italic mb-2 font-semibold" data-id="element-167">
                Con este manual:
              </p>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-168">
                En 7 días, sabes exactamente qué cadena te ha tenido atada. Y
                tienes el protocolo para cortarla para siempre.
              </p>
            </div>
          </div>

          <p className="text-lg text-charcoal-light mb-6 max-w-lg mx-auto" data-id="element-169">
            La diferencia entre los dos caminos cuesta hoy{' '}
            <span className="text-gold-dark font-bold text-xl" data-id="element-170">$8.49 USD</span>.
          </p>

          <CTAButton pulse href="https://innershiftstore.com/cart/51882289398042:1" text="SÍ, QUIERO ROMPER MIS CADENAS HOY" className="w-full md:w-auto md:px-12 py-5 text-xl mb-6" data-id="element-171" />

          <div className="flex flex-col items-center justify-center gap-2 text-sm text-charcoal-light mt-2" data-id="element-172">
            <div className="flex items-center gap-2 font-medium text-green-700 bg-green-50 px-4 py-2 rounded-full" data-id="element-173">
              <Lock size={16} data-id="element-174" />
              COMPRA 100% SEGURA Y PROTEGIDA
            </div>
            <p data-id="element-175">
              Acceso inmediato tras el pago. Garantía de satisfacción de 30 días
              o te devolvemos tu dinero al instante.
            </p>

            {/* Payment methods */}
            <div className="flex items-center justify-center gap-2 mt-3" data-id="element-176">
              <div className="bg-white border border-gray-200 rounded-md h-8 w-14 flex items-center justify-center" data-id="element-177">
                <span className="font-bold text-[#1A1F71] text-[11px] italic tracking-tight" data-id="element-178">
                  VISA
                </span>
              </div>
              <div className="bg-white border border-gray-200 rounded-md h-8 w-14 flex items-center justify-center" data-id="element-179">
                <svg width="24" height="16" viewBox="0 0 24 16" fill="none" data-id="element-180">
                  <circle cx="9" cy="8" r="6" fill="#EB001B" data-id="element-181" />
                  <circle cx="15" cy="8" r="6" fill="#F79E1B" data-id="element-182" />
                  <path d="M12 3.2C13.3 4.3 14.1 6 14.1 8C14.1 10 13.3 11.7 12 12.8C10.7 11.7 9.9 10 9.9 8C9.9 6 10.7 4.3 12 3.2Z" fill="#FF5F00" data-id="element-183" />
                </svg>
              </div>
              <div className="bg-[#FFC439] border border-[#FFC439] rounded-md h-8 w-14 flex items-center justify-center" data-id="element-184">
                <span className="font-extrabold text-[#003087] text-[10px]" data-id="element-185">
                  Pay<span className="text-[#009CDE]" data-id="element-186">Pal</span>
                </span>
              </div>
              <div className="bg-white border border-gray-200 rounded-md h-8 w-14 flex items-center justify-center" data-id="element-187">
                <svg width="36" height="15" viewBox="0 0 36 15" fill="none" data-id="element-188">
                  <path d="M7.2 3.5C6.9 3.9 6.4 4.2 5.9 4.2C5.8 3.7 6.1 3.2 6.3 2.8C6.6 2.4 7.2 2 7.6 2C7.7 2.5 7.5 3 7.2 3.5ZM7.6 4.5C6.8 4.4 6.1 4.9 5.7 4.9C5.3 4.9 4.7 4.5 4.1 4.5C3.2 4.5 2.3 5.1 1.9 5.9C1 7.5 1.6 9.9 2.5 11.2C3 11.8 3.5 12.5 4.2 12.5C4.8 12.5 5.1 12.1 5.8 12.1C6.6 12.1 6.8 12.5 7.5 12.5C8.2 12.5 8.6 11.8 9.1 11.2C9.6 10.5 9.8 9.8 9.8 9.7C9.8 9.7 8.5 9.2 8.5 7.7C8.5 6.5 9.5 5.9 9.6 5.9C9 5 8.2 4.5 7.6 4.5Z" fill="black" data-id="element-189" />
                  <text x="12" y="11" fill="black" fontSize="9" fontFamily="system-ui, -apple-system, sans-serif" fontWeight="600" data-id="element-190">
                    Pay
                  </text>
                </svg>
              </div>
              <div className="bg-black rounded-md h-8 w-14 flex items-center justify-center gap-0.5" data-id="element-191">
                <span className="text-[10px] font-bold" data-id="element-192">
                  <span className="text-[#4285F4]" data-id="element-193">G</span>
                </span>
                <span className="text-white text-[10px] font-semibold" data-id="element-194">
                  Pay
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}